export const TIER_LABELS = {
	health_first: 'Healthiest',
	balanced: 'Balanced',
	indulgent_last: 'Treat',
	legacy_collective: 'Combined',
	legacy_individual: 'Single ingredient'
};

export const TIER_ORDER = [
	'health_first',
	'balanced',
	'indulgent_last',
	'legacy_collective',
	'legacy_individual'
];

export function tierLabel(tier) {
	return TIER_LABELS[tier] || tier || 'Recipe';
}

export function tierVariant(tier) {
	if (tier === 'indulgent_last' || tier === 'legacy_individual') return 'indulgent';
	if (tier === 'balanced') return 'balanced';
	return 'health';
}
